import React from "react";
import '../css/yellowstripe.css'

function YellowStripe () {
    return (
        <div className="yellow_stripe_container">
            <div className="yellow_stripe_subcontainer">
                <p>10</p>
                <p>ODDANYCH WORKÓW</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipisc Pellentesque
                    vel enim a elit viverra elementuma. Aliquam erat volutpat.</p>
            </div>
            <div className="yellow_stripe_subcontainer">
                <p>5</p>
                <p>WSPARTYCH ORGANIZACJI</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipisc Pellentesque vel
                    enim a elit viverra elementuma. Aliquam erat volutpat.</p>
            </div>
            <div className="yellow_stripe_subcontainer">
                <p>7</p>
                <p>ZORGANIZOWANYCH ZBIÓREK</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipisc Pellentesque vel
                    enim a elit viverra elementuma. Aliquam erat volutpat.</p>
            </div>
        </div>
    )
}

export default YellowStripe